import type { I_AccordionItemProps } from './AccordionItem';

export enum E_AccordionType {
  MULTIPLE = 'multiple',
  SINGLE = 'single',
}

export interface I_AccordionProps {
  type?: E_AccordionType.MULTIPLE;
  items: I_AccordionItemProps[];
  className?: string;
  defaultValue?: string[];
}
